import * as React from 'react';
import {Component} from 'react';
import classNames from 'classnames';

interface TabPanelProps {
    selected?: boolean;
    key: string;
    children: React.ReactElement<any>;
}

export default class TabPanel extends Component<TabPanelProps, null> {
    render() {
        const {selected, children} = this.props;
        const panelClass = classNames('tab-panel', {
            selected
        });
        return (
            <div className={panelClass} aria-hidden={selected ? 'false' : 'true'}>
                {selected && children}
            </div>
        );
    }
}
